import { ArrowRight, Plus, Star } from 'lucide-react';
import moment from 'moment';
import { DATE_FORMATS } from 'utils/helpers';
import { HOUSEHOLD_LABELS, OUTLINE_PLAN_BTN } from './helper';

// A membership that has ended, and nothing in its place. The plan grid on its
// own reads like a first-time pitch, which leaves the patient to work out for
// themselves that their cover stopped — so this says what happened and gives
// them both ways forward rather than only the one that sells a plan.
const MembershipEnded = ({ enrollment, onChoosePlan = null, onAddInsurance = null }) => {
  const { plan_name, household_type, canceled_at, cancels_at } = enrollment || {};
  const ended = canceled_at || cancels_at;
  const household = HOUSEHOLD_LABELS[household_type] || household_type;

  return (
    <div className="animate-slide-up rounded-xl border border-gray-200 bg-secondary-50/60 p-4">
      <div className="flex items-start gap-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-gray-200 bg-white text-secondary-400">
          <Star size={20} />
        </span>

        <div className="min-w-0">
          <p className="text-[15px] font-bold text-secondary-900">
            Your {plan_name ? `${plan_name} ` : ''}membership has ended
          </p>
          <p className="mt-1 text-xs leading-relaxed text-secondary-500">
            {household && `The ${household.toLowerCase()} plan `}
            {ended ? `ended on ${moment(ended).format(DATE_FORMATS.medium)}, so member ` : 'has ended, so member '}
            pricing no longer applies and you're billed at standard prices. You can add your
            insurance now, or join again.
          </p>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-2.5 border-t border-gray-200 pt-4 sm:flex-row">
        {onAddInsurance && (
          <button type="button" onClick={onAddInsurance} className={`${OUTLINE_PLAN_BTN} gap-2 px-4`}>
            <Plus size={15} strokeWidth={2.5} />
            Add insurance
          </button>
        )}

        {onChoosePlan && (
          <button type="button" onClick={onChoosePlan} className={`${OUTLINE_PLAN_BTN} gap-2 px-4`}>
            Show membership options
            <ArrowRight size={15} />
          </button>
        )}
      </div>
    </div>
  );
};

export default MembershipEnded;
